import formFieldWidget from "./formFieldWidget.js";

/**
 * A form field widget wrapping any renderable so it can be added to a
 * form.
 *
 * @param {Renderable} spec.content - A renderable to add to the form.
 * @param {function} spec.getFormValue - A function taking no
 * argument and returning the form value associated with the
 * renderable.
 * @param {function} spec.setFormValue - A function taking a value
 * which should update the renderable accordingly.
 * @param {Renderable} [spec.append] - Any renderable to display after
 * the form field.
 * @param {boolean} [spec.showErrorExternally] - When true, the error handling
 *   is delegated to an external actor
 */
export default function renderableFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = formFieldWidget(spec, my);

	my.content = spec.content;
	my.getFormValue = spec.getFormValue;
	my.setFormValue = spec.setFormValue;
	my.content = spec.content;
	my.append = spec.append;

	my.showErrorExternally = spec.showErrorExternally ?? false;

	my.renderFieldOn = function (html) {
		html.render(my.content || "");

		if (my.append) {
			html.render(my.append);
		}
	};

	that.getValue = function () {
		return my.getFormValue();
	};

	const superSetValue = that.setValue;

	that.setValue = function (newValue) {
		my.setFormValue(newValue);

		return superSetValue(...arguments);
	};

	const superDisplayHelp = my.displayHelp;

	my.displayHelp = function (...args) {
		if (my.showErrorExternally) {
			return;
		}
		superDisplayHelp(...args);
	};

	const superValid = that.valid;

	that.valid = function (...args) {
		if (my.showErrorExternally) {
			return true;
		}

		return superValid(...args);
	};

	return that;
}
